import React from 'react';
import PropTypes from 'prop-types';
import { Box, Icon, IconWrapper } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './AddToBuildButton.styles';

const CheckmarkWrapper = themeStyles.apply(IconWrapper, 'CheckmarkWrapper');
const Container = themeStyles.apply(Box, 'Container');
const StyledLabel = themeStyles.apply(Box, 'StyledLabel');
const StyledCheckmark = themeStyles.apply(Box, 'StyledCheckmark');

const AddToBuildButton = ({ isOnBuild, onClick, disabled }) => {
  const { t } = useTranslation();

  const onClickHandler = e => {
    if (onClick) {
      e?.stopPropagation();
      onClick();
    }
  };

  const compareIconLabel = isOnBuild
    ? t('Sub-apps.PriceAndFinance.removeFromBuildButton')
    : t('Sub-apps.PriceAndFinance.addToBuildButton');

  return (
    <>
      <CheckmarkWrapper isOnBuild={isOnBuild} data-testid="cy-checkmark-icon">
        <Icon name="checkmark" iconColor="white" />
      </CheckmarkWrapper>
      <Container onClick={onClickHandler} data-testid="product-card-compare-btn">
        <StyledCheckmark
          as="span"
          disabled={disabled}
          isOnBuild={isOnBuild}
          aria-pressed={isOnBuild}
          data-testid="cy-add-to-build-icon"
        />
        <StyledLabel as="p" disabled={disabled} data-testid="cy-add-to-build-label">
          {compareIconLabel}
        </StyledLabel>
      </Container>
    </>
  );
};

AddToBuildButton.propTypes = {
  isOnBuild: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default AddToBuildButton;
